import React, {PropTypes as T} from 'react';
import Modal, {ModalHeader, ModalContent} from '../../common/modal';
import ModalSuccessIcon from '../../common/icons/icon_modal_success';
import ModalCautionIcon from '../../common/icons/icon_modal_caution';

export default class EventEligibilityModal extends React.Component {
  static propTypes = {
    eventIneligibilityCause: T.string
  };

  getModalType = () => {
    if (this.props.eventIneligibilityCause != null) {
      if (this.props.eventIneligibilityCause.length &&
          this.props.eventIneligibilityCause !== 'Event is not white-listed in the WAT') {
        return 'isError';
      }
    }
    return 'isSuccess';
  };

  getMessageText = (modalType) => {
    if (modalType === 'isError') {
      return '<b>Event is not eligible for the Seatmap EDP because: </b>' + this.props.eventIneligibilityCause;
    }
    return '<b>Event is eligible for the Seatmap EDP</b>';
  };

  renderIcon = (modalType) => {
    if (modalType === 'isError') {
      return (<ModalCautionIcon className="modal__header__icon" />);
    }
    return (<ModalSuccessIcon className="modal__header__icon" />);
  };

  render () {
    const modalType = this.getModalType();
    let msgText = {__html: this.getMessageText(modalType)};
    return (
      <Modal dataComponent="seatmap-event-eligibility-modal" isOpen>
        <ModalHeader isError={modalType === 'isError'} isSuccess={modalType !== 'isError'}>
          <div className="modal__header__icon__wrapper">
            {this.renderIcon(modalType)}
          </div>
          <div className="modal__header_title">Event Eligibility for Seatmap EDP</div>
        </ModalHeader>
        <ModalContent>
          <div dangerouslySetInnerHTML={msgText} />
        </ModalContent>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/errors/event_eligibility_modal.js